/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it

import React from "react"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"

import "./src/styles/global.css"
import "./src/styles/recaptcha.css"

export const wrapRootElement = ({ element }) => {
    return (
        <GoogleReCaptchaProvider reCaptchaKey="6LeSErwpAAAAAArBmr4r4S5fNwnwAXaBLK9MIz9X">
            {element}
        </GoogleReCaptchaProvider>
    )
}